import React, { useState, useEffect } from 'react'
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import serverData from '../../../../api/ServerData'
import { useNavigate } from 'react-router-dom'
import NestedModals from '../../../../commonComponents/NestedModals'
import { logoutUser } from '../../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import { isEmpty, showToast } from '../../../../utils/AppHelper'
import moment from 'moment'
import JobPostPreviewModal from '../postjob/JobPostPreviewModal'
import AppButton from '../../../../commonComponents/AppButton'
import { TextBold, TextRegular } from '../../../../commonComponents/TextStyling'
import appassets from '../../../../utils/appassets'
import MoneyIcon from '@mui/icons-material/Money'
import '../../../../App.css'
import { currencySymbol } from '../../../../utils/AppConstants'
import CustomModal from '../../../../commonComponents/CustomModal'
import MultiSelectUsers from './MultiSelectUsers'

export default function JobItem ({
  item,
  jobStatusData,
  getJobPosts,
  subEmployers,
  isSubEmployer
}) {
  const [previewModal, setPreviewModal] = useState({ open: false })
  var theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [modal, setModal] = useState('')
  const [customModal, setCustomModal] = useState({
    open: false
  })

  const [selectedEmployers, setSelectedEmployers] = useState([])

  const [discardAlert, setDiscardAlert] = useState({ open: false })
  const [discardLoading, setDiscardLoading] = useState(false)

  const [loadingBtn, setLoadingBtn] = useState(false)
  const [loadingAssignSubEmployer, setLoadingAssignSubEmployer] =
    useState(false)

  function putOnHoldOrActive (jobId, status) {
    setCustomModal({ open: false })
    setLoadingBtn(true)
    serverData.putOnHoldOrActive(
      { jobId, status },
      result => {
        if (result.status) {
          getJobPosts()
          showToast(result.message, false)
        } else {
          showToast(result.message)
        }
        setLoadingBtn(false)
      },
      error => {
        setLoadingBtn(false)

        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  function assignSubEmployersAPI (value, jobId) {
    setLoadingAssignSubEmployer(true)
    var body = {
      jobId: jobId,
      subEmployers: value.map(e => e.id)
    }
    serverData.assignSubEmployer(
      body,
      data => {
        if (data.status) {
          setSelectedEmployers(value)
        } else {
          showToast(data.message)
        }
        setLoadingAssignSubEmployer(false)
      },
      error => {
        setLoadingAssignSubEmployer(false)

        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const paraStyle = {
    marginBottom: '15px',
    fontSize: '13px'
  }
  useEffect(() => {
    setSelectedEmployers(
      subEmployers.filter(e =>
        item.subEmployers.split(',').includes(e.id.toString())
      )
    )
  }, [subEmployers])

  return (
    <>
      <Grid
        container
        style={{
          padding: '15px 20px',
          display: 'flex',
          background: theme.palette.background.paper,
          borderRadius: '16px',
          marginBottom: '15px',
          boxShadow: '1px 1px 5px #ccc',
          position: 'relative'
        }}
      >
        <Grid item xs={12} style={{ marginBottom: '10px' ,}}>
          <TextBold
            style={{
              fontSize: '22px',
              color: theme.palette.text.primary,
              // color: theme.palette.primary.main,
              cursor: 'pointer',
              fontWeight: '700'
            }}
            onClick={() => {
              navigate('/employer/jobdetails', {
                state: { item }
              })
            }}
          >
            {item?.jobTitle}
          </TextBold>
        </Grid>
        {[
          {
            icon: <img src={`${appassets.location}`} alt='location' />,
            value: `${item.city}`
          },
          {
            icon: <img src={`${appassets.suitcase}`} alt='suitcase' />,
            value: item.jobTypeName
          },
          {
            icon: <img src={`${appassets.time}`} alt='time' />,
            value: moment(item?.createdAt).fromNow()
          },
          {
            icon: (
              <MoneyIcon
                style={{
                  color: theme.palette.text.secondary
                }}
              />
            ),
            value: item.commissionFromEmployer
              ? `${currencySymbol} ${item.commissionFromEmployer}`
              : null
          }
        ].map(row =>
          row.value ? (
            <Grid
              item
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingRight: '16px'
              }}
            >
              {row.icon}
              <TextRegular
                style={{
                  fontSize: '14px',
                  color: theme.palette.text.secondary,
                  fontWeight: '600',
                  paddingLeft: '8px'
                }}
              >
                {row.value}
              </TextRegular>
            </Grid>
          ) : null
        )}

        {jobStatusData === 'closed' && (
          <>
            <Grid xs={12} style={{ marginTop: 16 }}>
              <TextBold style={{ fontSize: 16 }}>
                {item?.rejectedOn ? 'Rejected on' : 'Closed on'}:{' '}
              </TextBold>
              <TextRegular>
                {moment(item?.rejectedOn || item?.updatedAt).format(
                  'D MMMM YYYY, dddd'
                )}
              </TextRegular>
            </Grid>
            <Grid xs={12} style={{ marginTop: 16 }}>
              <TextBold style={{ fontSize: 16 }}>Close Reasons:</TextBold>
            </Grid>
            {item.closeReasons.map(reason => (
              <Grid xs={12} style={{ marginLeft: 8 }}>
                <TextRegular>• {reason}</TextRegular>
              </Grid>
            ))}
            {!isEmpty(item.closeReasonOther) && (
              <Grid xs={12} style={{ marginLeft: 8 }}>
                <TextRegular>• {item.closeReasonOther}</TextRegular>
              </Grid>
            )}
          </>
        )}
        <Grid item xs={12} style={{ display: 'flex' }}>
          <div
            style={paraStyle}
            className='ellipsis'
            dangerouslySetInnerHTML={{
              __html: `${item?.jobDescription}`
            }}
          />
        </Grid>
        <AppButton
          style={{ padding: 0 }}
          fullWidth={false}
          name={'View more'}
          variant='text'
          onClick={() => {
            navigate('/employer/jobdetails', {
              state: { item }
            })
          }}
        />
        {jobStatusData === 'pending' && (
          <Grid
            sx={{
              background: '#ffe9e0',
              padding: '5px 15px',
              color: theme.palette.primary.main,
              fontSize: '13px',
              fontWeight: 'bold',
              position: 'absolute',
              top: '10px',
              right: '10px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img src={appassets.jobPending} style={{ marginRight: '7px' }} />
            Pending
            <img
              src={appassets.arrowRight}
              style={{ marginLeft: '10px', width: '7px' }}
            />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          style={{ display: 'flex', alignItems: 'center', marginTop: 10,flexWrap:'wrap',gap:'16px' }}
        >
          {jobStatusData === 'pending' && (
            <>
              <div style={{ margin: '0px 6px 0 0' }}>
                <AppButton
                  startIcon={
                    <img
                      src={appassets.copy}
                      alt='copy'
                      style={{ width: 15, height: 15 }}
                    />
                  }
                  name={'Post a copy of this job'}
                  style={{
                    fontSize: '15px',
                    padding: '9px 15px',
                    borderRadius: '8px',
                    backgroundColor: 'transparent',
                    color: '#000',
                    border: '2px solid #d6d6d6',
                    fontWeight: 'bold',
                    boxShadow: 'none'
                  }}
                  onClick={() => {
                    navigate('/employer/postnewjob', {
                      state: { item, isAdd: true }
                    })
                  }}
                />
              </div>
              <div style={{ margin: '0px' }}>
                <AppButton
                  startIcon={
                    <img
                      src={appassets.editJob}
                      alt='copy'
                      style={{ width: 15, height: 15 }}
                    />
                  }
                  name={'Edit this job'}
                  style={{
                    fontSize: '15px',
                    padding: '9px 15px',
                    borderRadius: '8px',
                    backgroundColor: 'transparent',
                    color: '#000',
                    border: '2px solid #d6d6d6',
                    fontWeight: 'bold',
                    boxShadow: 'none'
                  }}
                  onClick={() =>
                    navigate('/employer/postnewjob', {
                      state: { item, isEdit: true }
                    })
                  }
                />
              </div>
            </>
          )}
          {jobStatusData !== 'filled' &&
            jobStatusData !== 'closed' &&
            !isSubEmployer &&
            item.closedPositions === 0 && (
              <div style={{ margin: '0px 6px' }}>
                <AppButton
                  startIcon={
                    <img
                      src={appassets.close}
                      alt='copy'
                      style={{ width: 15, height: 15 }}
                    />
                  }
                  name={'Close'}
                  style={{
                    fontSize: '15px',
                    padding: '9px 15px',
                    borderRadius: '8px',
                    backgroundColor: 'transparent',
                    color: '#000',
                    border: '2px solid #d6d6d6',
                    fontWeight: 'bold',
                    boxShadow: 'none'
                  }}
                  onClick={() =>
                    setModal({
                      open: true,
                      item,
                      onClose: isReload => {
                        if (isReload === true) {
                          getJobPosts()
                        }
                        setModal(false)
                      }
                    })
                  }
                />
              </div>
            )}

          {jobStatusData === 'draft' && (
            <>
              <div style={{ margin: '0px 6px' }}>
                <AppButton
                  name={'Review & post this job'}
                  style={{
                    fontSize: '14px',
                    padding: '9px 15px',
                    borderRadius: '8px'
                  }}
                  onClick={() => {
                    navigate('/employer/postnewjob', {
                      state: { item, isEdit: true }
                    })
                  }}
                />
              </div>

              <div style={{ margin: '0px 6px' }}>
                <AppButton
                  name={'Preview'}
                  style={{
                    fontSize: '14px',
                    borderRadius: '8px',
                    padding: '12px 27px'
                  }}
                  onClick={() => {
                    setPreviewModal({
                      open: true,
                      company: item.companyname,
                      jobDescription: item.jobDescription,
                      title: item.jobTitle,
                      type: item.jobTypeName,
                      jobFunction: item.jobFunctionName,
                      // industry: item.jobIndustryName,
                      // experienceLevel: item.experienceLevelName,
                      // education: item.educationLevelName,
                      // compensationFrom: item.jobCompensationAmountMin,
                      // compensationTo: item.jobCompensationAmountMax,
                      // state: item.state,
                      // country: item.country,
                      // zipCode: item.zipCode,
                      skill: item.skillRequired,
                      // experienceYears: item.requiredExpYear,
                      // experienceMonths: item.requiredExpMonth,
                      onClose: () => {
                        setPreviewModal({
                          open: false
                        })
                      }
                    })
                  }}
                />
              </div>

              <div style={{ margin: '0px 6px' }}>
                <AppButton
                  name={'Discard'}
                  onClick={() => {
                    setDiscardAlert({ open: true, item })
                  }}
                  style={{
                    padding: '9px 15px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    backgroundColor: theme.palette.text.error
                  }}
                />
              </div>
            </>
          )}
          {jobStatusData === 'active' && (
            <>
              <div style={{ margin: '0px 6px' }}>
                <AppButton
                  disabled={false}
                  loading={loadingBtn}
                  startIcon={
                    <img
                      src={appassets.hold}
                      alt='Hold'
                      style={{ width: 15, height: 15 }}
                    />
                  }
                  onClick={() => {
                    setCustomModal({
                      open: true,
                      title: 'Confirm to put On-Hold?',
                      message: `Are you sure, you want to put this job on-hold?`,
                      onClose: () => {
                        setCustomModal({ open: false })
                      },
                      positiveBtnText: 'YES',
                      onClickPositiveButton: () => {
                        putOnHoldOrActive(item.jobId, 'onhold')
                      },
                      negativeBtnText: 'NO',
                      onClickNegativeButton: () => {
                        setCustomModal({ open: false })
                      }
                    })
                  }}
                  name={'Put on Hold'}
                  style={{
                    width: 'fit-content',
                    fontSize: '15px',
                    padding: '9px 15px',
                    borderRadius: '8px',
                    backgroundColor: 'transparent',
                    color: '#000',
                    border: '2px solid #d6d6d6',
                    fontWeight: 'bold',
                    boxShadow: 'none'
                  }}
                />
              </div>
              {subEmployers.length > 0 && (
                <div
                  style={{
                    margin: '0px 6px',
                    alignItems: 'center',
                    display: 'flex',
                    marginright: '20px',
                    width:'100%'
                  }}
                >
                  <MultiSelectUsers
                    label={'Select users'}
                    options={subEmployers}
                    selectedValues={selectedEmployers}
                    onChange={value => {
                      assignSubEmployersAPI(value, item.jobId)
                    }}
                  />
                  {loadingAssignSubEmployer && <CircularProgress size={24} />}
                </div>
              )}
            </>
          )}
          {jobStatusData === 'onhold' && (
            <AppButton
              disabled={false}
              loading={loadingBtn}
              startIcon={
                <img
                  src={appassets.userActive}
                  alt='Hold'
                  style={{ width: 15, height: 15 }}
                />
              }
              onClick={() => {
                setCustomModal({
                  open: true,
                  title: 'Confirm to Active?',
                  message: `Are you sure, you want to active this job?`,
                  onClose: () => {
                    setCustomModal({ open: false })
                  },
                  positiveBtnText: 'YES',
                  onClickPositiveButton: () => {
                    putOnHoldOrActive(item.jobId, 'active')
                  },
                  negativeBtnText: 'NO',
                  onClickNegativeButton: () => {
                    setCustomModal({ open: false })
                  }
                })
              }}
              name={'Active'}
              style={{
                width: 'fit-content',
                fontSize: '15px',
                padding: '9px 15px',
                borderRadius: '8px',
                backgroundColor: 'transparent',
                color: '#000',
                border: '2px solid #d6d6d6',
                fontWeight: 'bold',
                boxShadow: 'none'
              }}
            />
          )}
        </Grid>
      </Grid>

      {modal?.open && <NestedModals data={modal} />}
      <JobPostPreviewModal data={previewModal} />

      <CustomModal data={customModal} />

      <Dialog
        open={discardAlert?.open}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Do you really want to discard this job?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <AppButton
            name={'No'}
            variant='text'
            fullWidth={false}
            disabled={discardLoading}
            onClick={() => {
              setDiscardAlert({ open: false })
            }}
          />

          <AppButton
            name={'Yes'}
            variant='text'
            fullWidth={false}
            loading={discardLoading}
            onClick={() => {
              setDiscardLoading(true)
              serverData.discardJob(
                {
                  jobId: discardAlert.item.jobId,
                  isNotifyUsers: false
                },
                result => {
                  if (result.status) {
                    getJobPosts()
                    showToast(result.message, false)
                    setDiscardAlert({ open: false })
                  } else {
                    showToast(result.message)
                  }
                  setDiscardLoading(false)
                },
                error => {
                  setDiscardLoading(false)

                  if (error.status === 401) {
                    dispatch(logoutUser(navigate)) // eslint-disable-next-line
                  }
                }
              )
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  )
}
